// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3adb1a7e","513":"7cb60e89","615":"a08b4d07"}[chunkId] + ".chunk.js";
};